import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  root: {
    display: "flex",
    flexFlow: "row nowrap",
    alignItems: "center",
    paddingBottom: theme.spacing(1),
    width: "auto",
    color: theme.palette.getContrastText(theme.palette.background.paper)
  },
  icon: {
    height: 18,
    marginRight: 5,
    color: theme.palette.getContrastText(theme.palette.background.paper)
  },
  text: {
    color: theme.palette.getContrastText(theme.palette.background.paper)
  }
}));
